<template>
  <BaseModal :title="context.title">
    <template #default>
      <p class="text-sm mb-20">
        {{ context.description }}
      </p>
      <Autocomplete v-model="currency" :items="currencySelectItems" />
    </template>
    <template #footer>
      <div class="flex-between flex-row-reverse width-100">
        <div class="spacex-8">
          <Button color="neutral" @click="closeModal">
            {{ $t('Cancel') }}
          </Button>
          <Button @click="handleCurrencyConfirm">
            {{ $t('Proceed with') }} {{ currencyWithSymbol(currency) }}
          </Button>
        </div>
        <div v-if="context.error" class="warning-600">{{ context.error }}</div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import Button from '@/components/ui/Button';
  import Autocomplete from '@/components/ui/Autocomplete';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { DEFAULT_CURRENCY } from '@/utils/constants/common';

  export default {
    name: 'ChooseCurrencyWindow',
    components: {
      BaseModal,
      Button,
      Autocomplete,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          title: String,
          description: String,
          error: String,
          emitter: Function,
        }),
      },
    },
    data() {
      return {
        currency: DEFAULT_CURRENCY,
      };
    },
    computed: {
      ...mapGetters('global', ['currencySelectItems', 'currencyWithSymbol']),
      ...mapState('global', ['currencies']),
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      handleCurrencyConfirm() {
        this.context.emitter({ currency: this.currency });
      },
    },
  };
</script>

<style scoped></style>
